import '../css/footer.css';
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";



function Footer() {
  return (
    <div className="Footer">
      <Container>
        <Row className="text-center text-md-start">
          {/* Column 1 - About */}
          <Col md={6}>
            <h5 className="fw-bold">Pathway AI</h5>
            <p>Smarter college & academic decisions, personalized for you.</p>
          </Col>

          {/* Column 2 - Quick Links
          <Col md={4}>
            <h5 className="fw-bold">Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="" className="footer-link">Features</a></li>
              <li><a href="" className="footer-link">Pricing</a></li>
              <li><a href="" className="footer-link">About Us</a></li>
              <li><a href="" className="footer-link">Contact</a></li>
            </ul>
          </Col> */}

          {/* Column 3 - Social Media */}
          <Col md={6}>
            <h5 className="fw-bold">Follow Us</h5>
            <div className="social-icons">
              {/* <a href="" className="social-link"><FaFacebook size={24} /></a>
              <a href="" className="social-link"><FaTwitter size={24} /></a> */}
              <a className="social-link" href="https://instagram.com/austinatose"><FaInstagram size={24} /></a>
              {/* <a href="" className="social-link"><FaLinkedin size={24} /></a> */}
            </div>
          </Col>
        </Row>

        {/* Copyright Section */}
        <hr className="my-3" />
        <Row>
          <Col className="text-center">
            <p className="disclaimer">
              This website is a mock project designed solely for REN (Raffles Entrepreneur’s Network) trials. Pathway AI is not a commercial product, and no real services, data, or transactions are associated with this platform. Any resemblance to real companies, features, or services is purely coincidental.
            </p>
            <p className="mb-0">© {new Date().getFullYear()} Austin Liu. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;

// needs work